import React, { Component } from 'react';
import Intro from "./Intro";
import Projects from "./Projects";

class Works extends Component {
  render(){
    return(
      <div>
        <Intro/>
        <Projects/>
      </div>
    );
  }
}

export default Works;



// WEBPACK FOOTER //
// ./src/components/Works/Works.js